import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  padding: 4rem;
  position: relative;
  overflow: hidden;
`;

const Logo = styled(motion.div)`
  font-size: 6rem;
  font-weight: 900;
  color: #EF443C;
  margin-bottom: 3rem;
  text-shadow: 0 4px 12px rgba(239, 68, 60, 0.3);
`;

const FlowDiagram = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 4rem;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1200px;
`;

const FlowItem = styled(motion.div)`
  background: white;
  padding: 2rem 3rem;
  border-radius: 16px;
  font-size: 1.8rem;
  font-weight: 600;
  color: #042E4B;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  border: 3px solid #EF443C;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Arrow = styled.div`
  font-size: 2.5rem;
  color: #EF443C;
`;

const FeaturesList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 900px;
  width: 100%;
`;

const FeatureCard = styled(motion.div)`
  background: linear-gradient(135deg, #042E4B, #0A4A6F);
  color: white;
  padding: 2rem;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  box-shadow: 0 6px 24px rgba(4, 46, 75, 0.3);
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  width: 70px;
  height: 70px;
  background: rgba(239, 68, 60, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const FeatureText = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;

const Slide6Solucao: React.FC = () => {
  const flowSteps = [
    { icon: '🎯', text: 'Objetivos' },
    { icon: '📊', text: 'Metas' },
    { icon: '📋', text: 'Ações' },
    { icon: '📈', text: 'Resultados' },
  ];

  const features = [
    { icon: '✅', text: 'Define' },
    { icon: '🔗', text: 'Conecta' },
    { icon: '👁️', text: 'Acompanha' },
    { icon: '🚀', text: 'Transforma' },
  ];

  return (
    <Container>
      <Logo
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        ThinkWay
      </Logo>

      <FlowDiagram>
        {flowSteps.map((step, index) => (
          <React.Fragment key={`flow-${step.text}`}>
            <FlowItem
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.1 + index * 0.08 }}
            >
              <span>{step.icon}</span>
              <span>{step.text}</span>
            </FlowItem>
            {index < flowSteps.length - 1 && <Arrow>→</Arrow>}
          </React.Fragment>
        ))}
      </FlowDiagram>

      <FeaturesList>
        {features.map((feature, index) => (
          <FeatureCard
            key={`feature-${feature.text}`}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.5 + index * 0.05 }}
          >
            <FeatureIcon>{feature.icon}</FeatureIcon>
            <FeatureText>{feature.text}</FeatureText>
          </FeatureCard>
        ))}
      </FeaturesList>
    </Container>
  );
};

export default Slide6Solucao;
